import React from 'react';

import './spinner.css';

export const Spinner = () => <div className="loader">Loading...</div>
